import type { GeneratedDoorPlacement } from "building-types/doors/doorTypes";
import type { WallCut } from "building-types/walls/wallCutTypes";
import type { WallGapSource, WallGap, StartSortedWallGaps, WallGapDescriptor } from "building-types/walls/wallGap";
import type { GeneratedWindowPlacement } from "building-types/windows/windowTypes";
import type { PolyLine2 } from "geom/polyLine2Types";

export function wallGapNew(
  openings: (GeneratedWindowPlacement | GeneratedDoorPlacement | WallCut)[],
  start: number,
  center: number,
  end: number,
  bottom: number,
  height: number,
  hasStartCasing: boolean,
  hasEndCasing: boolean,
  noMerge?: boolean,
  source?: WallGapSource,
  sourceId?: string,
): WallGap {
  return {
    openings,
    start,
    center,
    end,
    bottom,
    height,
    hasStartCasing,
    hasEndCasing,
    noMerge,
    source,
    sourceId,
  };
}

export function startSortedWallGapsNew(edge: PolyLine2, gaps: WallGap[]): StartSortedWallGaps {
  return {
    edge,
    gaps: gaps.slice().sort((a, b) => a.start - b.start),
  };
}
export function wallGapDescriptorNew(
  start: number,
  center: number,
  end: number,
  bottom: number,
  height: number,
  id: string,
): WallGapDescriptor {
  return {
    start,
    center,
    end,
    bottom,
    height,
    id,
  };
}
